<template>
    <div class="pt-2">
        <b-row>
            <b-col class="mb-4" cols="12">
                <span v-html="text.top"/>
            </b-col>
        </b-row>

        <b-row v-if="categories.topLeft && !categories.topLeft.isHidden" class="mb-2">
            <b-col cols="12" lg="8" class="mx-auto iat-item__target">
                <div class="iat-block-intro__category px-3 py-2">
                    <div class="iat-block-intro__category-name">
                        {{ categories.topLeft.title }}
                    </div>
                    <div class="iat-block-intro__category-words">
                        <span v-for="(word, i) in categories.topLeft.words" :key="'word-'+i">
                            {{ word }}{{ isLast(i, categories.topLeft.words.length) ? '' : ',' }}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="categories.bottomLeft && !categories.bottomLeft.isHidden" class="mb-2">
            <b-col cols="12" lg="8" class="mx-auto iat-item__aux">
                <div class="iat-block-intro__category px-3 py-2">
                    <div class="iat-block-intro__category-name">
                        {{ categories.bottomLeft.title }}
                    </div>
                    <div class="iat-block-intro__category-words">
                        <span v-for="(word, i) in categories.bottomLeft.words" :key="'word-'+i">
                            {{ word }}{{ isLast(i, categories.bottomLeft.words.length) ? '' : ',' }}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="text.middle">
            <b-col class="mb-4" cols="12">
                <span v-html="text.middle"/>
            </b-col>
        </b-row>
        <b-row v-if="categories.topRight && !categories.topRight.isHidden" class="mb-2">
            <b-col cols="12" lg="8" class="mx-auto iat-item__target">
                <div class="iat-block-intro__category px-3 py-2">
                    <div class="iat-block-intro__category-name">
                        {{ categories.topRight.title }}
                    </div>
                    <div class="iat-block-intro__category-words">
                        <span v-for="(word, i) in categories.topRight.words" :key="'word-'+i">
                            {{ word }}{{ isLast(i, categories.topRight.words.length) ? '' : ',' }}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="categories.bottomRight && !categories.bottomRight.isHidden" class="mb-2">
            <b-col cols="12" lg="8" class="mx-auto iat-item__aux">
                <div class="iat-block-intro__category px-3 py-2">
                    <div class="iat-block-intro__category-name">
                        {{ categories.bottomRight.title }}
                    </div>
                    <div class="iat-block-intro__category-words">
                        <span v-for="(word, i) in categories.bottomRight.words" :key="'word-'+i">
                            {{ word }}{{ isLast(i, categories.bottomRight.words.length) ? '' : ',' }}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="mb-4" cols="12">
                <span v-html="text.bottom"/>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    name: 'iatBlockIntro',
    props: {
        text: {
            type: Object
        },
        categories: {
            type: Object
        }
    },
    methods: {
        isLast(i, length) {
            return i === length - 1
        }
    }
}
</script>
<style lang="scss">
.iat-block-intro__category {
    background: white;
    border-radius: 15px;
    -webkit-box-shadow: -2px 4px 11px -1px rgba(201,201,201,0.5);
    -moz-box-shadow: -2px 4px 11px -1px rgba(201,201,201,0.5);
    box-shadow: -2px 4px 11px -1px rgba(201,201,201,0.5);
}

.iat-block-intro__category-name {
    font-size: 1.2em;
    font-weight: 600;
} 
</style>
